export default class LiegtypselectObject {
    constructor() {
    /** @type {string} */
        this.typ;
        /** @type {string} */
        this.sektion;
        /** @type {string} */
        this.parznr;
        /** @type {string} */
        this.egrid;
    }
}
